import { GatewaySearchResponse } from "../../features/api-interfaces";
import { DivisionDict } from "../default-constants";

//個別相談案件相談内容のラベル
export const LABELS = {
  CONSULTATION_CONTENT: "相談内容",
  MERCHANTS_NAME: "加盟店名",
  SERVICE_NAME: "サービス名",
  COMPANY_NAME: "事業者名",
  CONTRACT_DETAILS: "契約内容",
  CONTRACT_STATUS: "契約形態",
  CONTRACT_ROUTE: "契約ルート",
  CONSULTATION_INFO: "相談者情報",
  RECEPTION_DATE: "受付日",
  CONSULATION_REASON: "相談理由",
  CONSULATION_RESULT: "相談結果",
  EXAMINATION_POLICY_RESULT: "検討方針・結果",
  EXAMINATION_STATUS: "検討状況",
  EXAMINATION_POLICY: "検討方針",
  EXAMINATION_POLICY_DETAIL: "検討方針詳細",
  EXAMINATION_RESULT: "検討結果",
  EXAMINATION_MEMO: "検討メモ",
  CREDIT_RATE: "クレカ料率",
  AFTER_MERCHANTS_INFO: "申し込み後加盟店情報",
  APPLICATION_PROCEDURE_MATTER: "申請手続き時の申し送り事項",
  PROCEDURE_MATTER: "申し送り事項",
  CONTRACT_DIRECTLY: "直接",
  CONTRACT_COMPREHENSIVE: "包括",
  EXAMINATION_UNDER: "検討中",
  REQUIRED: "必須",
  PARAM: "%",
  LAST_UPDATER: "最終更新者",
  LAST_UPDATING_TIME: "最終更新日",
};
export const PLACE_APPLICATION = {
  DATE_FORMAT: "YYYY/MM/DD",
  FONT_SIZE: "30文字以内",
  FONT_SIZE_MERCHANTS: "100文字以内",
};

// 契約形態
export const CONTRACT_STYLES = [
  { label: LABELS.CONTRACT_DIRECTLY, value: "1" },
  { label: LABELS.CONTRACT_COMPREHENSIVE, value: "2" },
  { label: LABELS.EXAMINATION_UNDER, value: "3" },
];

// 直接店舗取得結果変換
export const getGwCompanyList = (
  store: GatewaySearchResponse[] | undefined
): DivisionDict[] => {
  if (store !== undefined) {
    return store.map((store) => ({
      label: store.gwCompanyName,
      value: store.gwCompanyName,
    }));
  }
  return [];
};
